import useMapStateStore from "@alpaca-travel/react-mapbox-gl/use-map-style-store";
import { useEffect, useMemo, useState } from "react";
import useMapboxAccessToken from "@/use-mapbox-access-token";

const useMapStyle = () => {
  const [isLoading, setIsLoading] = useState(false);

  const { setBaseMapStyle } = useMapStateStore();
  const { accessToken } = useMapboxAccessToken();

  const styleUrl = useMemo(() => {
    return `https://api.mapbox.com/styles/v1/alpacatravel/cjzxbabwx03lb1cqjfy6f9voy?sdk=js-3.1.2&access_token=${accessToken}`;
  }, [accessToken]);

  useEffect(() => {
    let mounted = true;
    const safe = (fn: Function, ...args: any[]) => {
      if (mounted) {
        fn(...args);
      }
    };

    const retrieveStyle = async () => {
      try {
        const response = await fetch(styleUrl);
        const json = await response.json();

        safe(setBaseMapStyle, json);
      } finally {
        safe(setIsLoading);
      }
    };

    if (styleUrl != null) {
      safe(setIsLoading, true);
      retrieveStyle();
    }

    return () => {
      mounted = false;
    };
  }, [styleUrl, setBaseMapStyle]);

  return { isLoading };
};

export default useMapStyle;
